import { useQuery } from '@tanstack/react-query';

import { getActivePlanAssignmentsOptions } from '@cfa/pathway-fe-shared/xp';

/**
 * Whether the current user has an active assignment for `planId`.
 * Uses the My Plans list cache (`getActivePlanAssignmentsOptions`).
 *
 * `isAssigned` is `undefined` until the list query settles successfully;
 * then `true` / `false`. Errors leave it `undefined` and set
 * `isAssignmentCheckError`.
 */
export const useIsAssignedToPlan = (
  planId: string,
  options?: { enabled?: boolean },
) => {
  const enabled = options?.enabled ?? true;

  const { data, isError, isSuccess, error } = useQuery({
    ...getActivePlanAssignmentsOptions(),
    enabled,
  });

  const isAssigned =
    enabled && isSuccess ? data.some(up => up.plan?.id === planId) : undefined;

  return {
    isAssigned,
    isAssignmentCheckError: enabled && isError,
    assignmentCheckError: error,
  };
};
